export default function (options) {
    const config = {
        fullscreen: false,
        minHeight: 0,
        ...options
    };

    return {
        init() {
            window.addEventListener('resize', () => {
                this.setHeight();
            })
            window.addEventListener('load', () => {
                this.setHeight();
            })
            window.dispatchEvent(new Event('resize'));
        },
        setHeight() {
            const { fullscreen, minHeight } = config;
            const childHeight = this.$refs.child.offsetHeight;
            const docHeight = document.documentElement.clientHeight;

            this.$el.style.height = childHeight + 'px';
            if (minHeight !== 0) {
                if (childHeight < minHeight) {
                    this.$el.style.height = minHeight + 'px';
                }
            }
            if (fullscreen) {
                // minimum height should be screen height 
                if (childHeight < docHeight) {
                    this.$el.style.height = docHeight + 'px';
                }
            }
        }
    }
}